import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import strings from "translate/language";
import {
  visitorList,
  getVisiterList,
  visitorFormUpdate,
} from "reduxStore/action/visitorActions";
import { useDispatch, useSelector } from "react-redux";
import {
  CallCenter,
  CPAgent,
  visitorStatus,
  MIS_RoleId,
  GRE,
  ClosingTL,
  CSTL,
} from "utils/constants";
import AllocateSM from "component/common/AllocateCM";
import { getConfiguration } from "reduxStore/action/masterActions";
import TableDataNotFound from "component/TableDataNotFound";
import { handleDetailResponse, handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Button from "component/Button";
import moment from "moment";
import usePage from "utils/usePage";
import Pagination from "component/common/Pagination";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import Select from "react-select";
import { getAgentProperty } from "reduxStore/action/propertyActions";

const Visitor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [getvisitorList, setVisitorList] = useState([]); // Always initialize as array
  const [propertyList, setPropertyList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialQueryFilterTriggered, setInitialQueryFilterTriggered] =
    useState(false);
  const [showAllocateModal, setShowAllocateModal] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const lastAllocatedLeadIdRef = useRef(null);
  const visitorListSelector = useSelector((state) => state?.visitor);
  const ReportListSelector = useSelector((state) => state.report);
  const propertySelector = useSelector((state) => state.propertyData);
  const visitorConfiguration = useSelector(
    (state) => state.visitorConfiguration,
  );

  console.log("Visitor grid data", getvisitorList);

  const { response: res } = useSelector((state) => state.login);
  const misRole = MIS_RoleId === res?.data?.role_id;
  const roleId = res?.data?.role_id;
  // Convert both to strings for comparison to handle ObjectId vs string
  const currentRoleId = String(roleId || "").trim();
  const greRoleId = String(GRE || "").trim();
  const closingTlRoleId = String(ClosingTL || "").trim();
  const cstlRoleId = String(CSTL || "").trim();
  const isGRE = currentRoleId === greRoleId;
  const canAllocateToCM =
    isGRE || currentRoleId === closingTlRoleId || currentRoleId === cstlRoleId;

  // Debug log (remove in production)
  console.log("Visitor List - GRE Check:", {
    roleId: currentRoleId,
    GRE: greRoleId,
    isGRE,
    loginData: res?.data,
  });

  const cpId = useSelector((state) => {
    let response = handleDetailResponse(state.login.response?.data);
    if (response.role_id === CallCenter) {
      return true;
    } else if (response.role_id === CPAgent) {
      return response?.cp_id;
    }
    return false;
  });

  useEffect(() => {
    dispatch(visitorFormUpdate({}));
  }, [dispatch]);

  const [visitorConfigurationData, setvisitorConfigurationData] = useState([]);
  const { create, view, edit, isAdmin, bulk } = usePermission({
    create: "add_visitor",
    view: "view_visitor",
    edit: "edit_visitor",
    bulk: "bulk_upload",
  });
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    visit_score: "",
    search_by_visisor_name: "",
    search_configuration: "",
    search_property_name: "",
    search_by_mobile_number: "",
    draft: "",
    qualified: "",
    lead_priority: "",
  });

  useEffect(() => {
    const start_date = query.get("start_date");
    const end_date = query.get("end_date");

    if (start_date && end_date) {
      setForm((prev) => ({
        ...prev,
        start_date,
        end_date,
      }));
      setEndDateDisable(false);
      setInitialQueryFilterTriggered(true);
    }
  }, []);

  // Wait until form has start/end date from query before filtering
  useEffect(() => {
    if (initialQueryFilterTriggered && form.start_date && form.end_date) {
      filterDetail();
      setInitialQueryFilterTriggered(false);
    }
  }, [initialQueryFilterTriggered, form.start_date, form.end_date]);

  useEffect(() => {
    dispatch(visitorFormUpdate({}));
  }, [dispatch]);

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Visitor Listing",
      metaDescription: "Visitor listing",
      canonicalLink: window.location.href,
    });
  }, []);

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "" && form.end_date === "") {
      formError = true;
      err["end_date"] = strings.endDateErr;
    }
    setFormVaild(err);
    return formError;
  };

  const filterDetail = () => {
    if (!handleValid()) {
      const commonParams = {
        limit: 10,
        offset: 0,
        start_date: form.start_date,
        end_date: form.end_date,
        visit_score: form.visit_score,
        search_configuration: form.search_configuration,
        search_by_visisor_name: form.search_by_visisor_name,
        search_by_mobile_number: form.search_by_mobile_number,
        draft: form.draft,
        qualified: form.qualified,
        lead_priority: form.lead_priority,
      };

      if (isAdmin) {
        dispatch(
          visitorList({
            ...commonParams,
            search_property_name: form?.site?.property_title,
            search_type: cpId ? 1 : 2,
          }),
        );
      } else {
        dispatch(
          getVisiterList({
            ...commonParams,
            property_id: form?.site?._id,
          }),
        );
      }
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      visit_score: "",
      search_configuration: "",
      search_by_visisor_name: "",
      search_property_name: "",
      site: "",
      search_by_mobile_number: "",
      draft: "",
      lead_priority: "",
      qualified: "",
    });
    setFormVaild({ ...formVaild, end_date: "" });
    if (isAdmin) {
      dispatch(
        visitorList({ search_type: cpId ? 1 : 2, limit: 10, offset: 0 }),
      );
    } else {
      dispatch(getVisiterList({ limit: 10, offset: 0 }));
    }
    setPage(0);
  };

  const handleInputField = (e) => {
    const nextFormState = { ...form, [e.target.name]: e.target.value };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({ ...formVaild, end_date: "" });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    const commonParams = {
      limit: 10,
      offset: newOffset,
      start_date: form.start_date,
      end_date: form.end_date,
      visit_score: form.visit_score,
      search_configuration: form.search_configuration,
      search_by_visisor_name: form.search_by_visisor_name,
      search_by_mobile_number: form.search_by_mobile_number,
      draft: form.draft,
      qualified: form.qualified,
      lead_priority: form.lead_priority,
    };

    if (isAdmin) {
      dispatch(
        visitorList({
          ...commonParams,
          search_property_name: form?.site?.property_title,
          search_type: cpId ? 1 : 2,
        }),
      );
    } else {
      dispatch(
        getVisiterList({
          ...commonParams,
          property_id: form?.site?._id,
        }),
      );
    }
  };

  // Fetch initial list
  useEffect(() => {
    if (isAdmin) {
      dispatch(
        visitorList({ search_type: cpId ? 1 : 2, limit: 10, offset: page }),
      );
    } else {
      dispatch(getVisiterList({ limit: 10, offset: page }));
    }
  }, [dispatch, page]);

  // Populate visitor list
  useEffect(() => {
    if (visitorListSelector?.response?.status === 200) {
      let visitorData = visitorListSelector?.response?.data || [];
      const safeVisitorData = Array.isArray(visitorData) ? visitorData : [];
      // GRE: after allocate, keep allocated lead out of list when refetch completes
      if (lastAllocatedLeadIdRef.current) {
        const idToExclude = String(lastAllocatedLeadIdRef.current);
        visitorData = safeVisitorData.filter(
          (v) => String(v._id || v.lead_id || "") !== idToExclude,
        );
        lastAllocatedLeadIdRef.current = null;
      } else {
        visitorData = safeVisitorData;
      }
      setVisitorList(visitorData);

      // Debug: Log visitor data for GRE role (remove in production)
      if (
        isGRE &&
        Array.isArray(safeVisitorData) &&
        safeVisitorData.length > 0
      ) {
        console.log(
          "Visitor List Data (GRE):",
          safeVisitorData.map((v) => ({
            _id: v._id,
            property_id: v.property_id,
            for_sm_id: v.for_sm_id,
            first_name: v.first_name,
          })),
        );
      }
    } else {
      setVisitorList([]);
    }
  }, [visitorListSelector, isGRE]);

  // Load property list
  useEffect(() => {
    if (isAdmin) {
      dispatch(getReportPropertyList({ limit: 10, offset: 0 }));
    } else {
      dispatch(getAgentProperty({ offset: 0, limit: "" }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (visitorConfiguration?.response?.status === 200) {
      setvisitorConfigurationData(visitorConfiguration.response.data);
    } else {
      setvisitorConfigurationData([]);
    }
  }, [visitorConfiguration]);

  useEffect(() => {
    if (!isAdmin && propertySelector?.response?.status === 200) {
      const filtered = propertySelector.response.data?.filter(
        (item) => item.status === true,
      );
      setPropertyList(filtered?.length > 0 ? handleListResponse(filtered) : []);
    }
  }, [propertySelector, isAdmin]);

  useEffect(() => {
    if (isAdmin && ReportListSelector?.reportPropertyList?.status === 200) {
      setPropertyList(
        handleListResponse(ReportListSelector.reportPropertyList.data),
      );
    }
  }, [ReportListSelector]);

  useEffect(() => {
    dispatch(getConfiguration());
  }, [dispatch]);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.visitor}
        parentListing={null}
        titleactive={strings.visitorList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByVisitorName}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            placeholder={strings.searchVisitorName}
                            name="search_by_visisor_name"
                            value={form.search_by_visisor_name}
                            onChange={handleInputField}
                          />
                        </div>
                      </div>

                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByConfiguration}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="search_configuration"
                            value={form.search_configuration}
                            onChange={handleInputField}
                          >
                            <option value="">
                              {strings.selectConfiguration}
                            </option>
                            {visitorConfigurationData?.length ? (
                              visitorConfigurationData.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            ) : (
                              <option>{strings.Loading}</option>
                            )}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByVistingScore}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="visit_score"
                            onChange={handleInputField}
                            value={form.visit_score}
                          >
                            <option defaultValue={null}>
                              {strings.selectVisitingScore}
                            </option>
                            <option value={"1"}>{strings.howToligh}</option>
                            <option value={"2"}>{strings.highTolow}</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByPropertyName}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (isAdmin) {
                                if (e.length > 1) {
                                  dispatch(
                                    getReportPropertyList({
                                      search_site: e,
                                      isLoadMore: true,
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    getReportPropertyList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                    }),
                                  );
                                }
                              }
                            }}
                            placeholder={strings.searchByPropertyName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                      </div>

                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByMobileNumber}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            placeholder={strings.searchMobileNumber}
                            name="search_by_mobile_number"
                            value={form.search_by_mobile_number}
                            onChange={handleInputField}
                            maxLength="10"
                          />
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.leadStatus}</span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="qualified"
                            onChange={handleInputField}
                            value={form.qualified}
                          >
                            <option value={""}>
                              {strings.selectLeadStatus}
                            </option>
                            <option value={true}>{strings.qualified}</option>
                            <option value={false}>{strings.unQualified}</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.leadPriority}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="lead_priority"
                            onChange={handleInputField}
                            value={form.lead_priority}
                          >
                            <option value={""}>
                              {strings.selectLeadPriority}
                            </option>
                            <option value={"hot"}>{strings.hot}</option>
                            <option value={"warm"}>{strings.warm}</option>
                            <option value={"cold"}>{strings.cold}</option>
                          </select>
                        </div>
                      </div>

                      <div className="row pt-3">
                        {/* Left side: Mobile Number Input */}
                        {isAdmin ? (
                          <div className="col-md-4"></div>
                        ) : (
                          <div className="col-md-4">
                            <span className="cardText">
                              {strings.searchByVistingType}
                            </span>
                            <select
                              className="form-control digits"
                              id="formcontrol-select1"
                              name="draft"
                              onChange={handleInputField}
                              value={form.draft}
                            >
                              <option value="">{strings.visitors}</option>
                              {/* <option value={""}>{strings.visitors}</option> */}
                              <option value={true}>
                                {strings.draftVisitors}
                              </option>
                            </select>
                          </div>
                        )}
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                          <div className=" d-flex align-items-end justify-content-end mt-4">
                            <button
                              className="btn btn-warning mr-2"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row pt-3">
              {!isAdmin && create && (
                <div className="col-md-6">
                  <div className="form-group">
                    <Button
                      className="btn btn-color"
                      onClick={() => navigatpage("/visitor_form")}
                      label={strings.addNewVisitor}
                    ></Button>
                  </div>
                </div>
              )}
            </div>

            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfVisitor}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr className="text-center">
                          <th scope="col">{strings.propertyName}</th>
                          <th scope="col">{strings.visitorName}</th>
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.sourceName}</th>
                          <th scope="col">{strings.configuration}</th>
                          <th scope="col">{strings.budget}</th>
                          <th scope="col">{strings.visitScore}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {getvisitorList?.length > 0 ? (
                          (Array.isArray(getvisitorList)
                            ? getvisitorList
                            : []
                          ).map((item, index) => {
                            return (
                              <tr key={index}>
                                <td style={{ inlineSize: "130px" }}>
                                  {item?.property_title
                                    ? item?.property_title
                                    : "-"}
                                </td>
                                <td style={{ inlineSize: "130px" }}>
                                  {`${item?.first_name || ""} ${
                                    item?.last_name || ""
                                  }`.trim()}
                                </td>
                                <td>
                                  {moment(item.createdDate).format(
                                    "DD-MM-yyyy hh:mm a",
                                  )}
                                </td>
                                {/* JUSTO-64: GRE – show CM/SCM name (created_for_cm_name) or SM name; others show SM only */}
                                <td>
                                  {isGRE
                                    ? item?.created_for_cm_name ||
                                      item?.created_for_sm_name ||
                                      "-"
                                    : item?.created_for_sm_name || "-"}
                                </td>
                                <td>
                                  {item?.configuration
                                    ? item.configuration
                                    : "-"}
                                </td>
                                {item?.budget_amount ? (
                                  <td>{item.budget_amount}</td>
                                ) : cpId ? (
                                  <td>
                                    {item?.min_rate}
                                    {item.min_rate ? item.min_rate_type : ""}
                                    {" - "}
                                    {item?.max_rate}
                                    {item.max_rate ? item.max_rate_type : ""}
                                  </td>
                                ) : (
                                  <td>
                                    {item?.min_budget}
                                    {item.min_budget
                                      ? item.min_budget_type
                                      : ""}
                                    {" - "}
                                    {item?.max_budget}
                                    {item.max_budget
                                      ? item.max_budget_type
                                      : ""}
                                  </td>
                                )}

                                <td>{item?.lead_score}</td>
                                <td>{visitorStatus[item?.lead_status]}</td>
                                <td className="p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-2 mr-1"
                                      aria-hidden="true"
                                      title={strings.viewVisitor}
                                      onClick={() => {
                                        navigatpage(`/viewvisitor/${item._id}`);
                                      }}
                                    ></i>
                                  )}
                                  {edit &&
                                    item?.lead_status <= 3 &&
                                    !misRole &&
                                    !isAdmin && (
                                      <i
                                        className="fa fa-edit theme-fa-icon "
                                        aria-hidden="true"
                                        title={strings.editVisitor}
                                        onClick={() => {
                                          const path =
                                            item.draft === true
                                              ? `/visitor_form_draft?lead_id=${item._id}`
                                              : `/visitor_form?lead_id=${item._id}`;
                                          navigatpage(path);
                                        }}
                                      ></i>
                                    )}
                                  {/* Allocate to CM/SCM even for LFSM (for_sm_id may exist); only block if already allocated to CM/SCM */}
                                  {canAllocateToCM &&
                                    !item?.for_cm_id &&
                                    item?.property_id && (
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-primary ml-2"
                                        style={{
                                          padding: "4px 8px",
                                          fontSize: "12px",
                                          marginLeft: "5px",
                                        }}
                                        title="Allocate to Closing Manager"
                                        onClick={() => {
                                          console.log(
                                            "Allocate button clicked:",
                                            {
                                              leadId: item._id,
                                              propertyId: item.property_id,
                                            },
                                          );
                                          setSelectedVisitor({
                                            leadId: item._id,
                                            propertyId: item.property_id,
                                          });
                                          setShowAllocateModal(true);
                                        }}
                                      >
                                        Allocate
                                      </button>
                                    )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={getvisitorList} />
                  </div>
                  <Pagination
                    totalCount={visitorListSelector?.response?.total_data}
                    listData={getvisitorList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* JUSTO-64: GRE/CTL – Allocate to Closing Manager / SCM modal */}
      {canAllocateToCM && selectedVisitor && (
        <AllocateSM
          show={showAllocateModal}
          propertyId={selectedVisitor.propertyId}
          leadId={selectedVisitor.leadId}
          handleClose={() => {
            setShowAllocateModal(false);
            setSelectedVisitor(null);
            // Do not refetch here – on success, onAllocateSuccess refetches; on cancel, list unchanged.
            // Refetching here caused a second response to overwrite the list and bring the allocated row back.
          }}
          onAllocateSuccess={() => {
            const leadIdToRemove = selectedVisitor?.leadId;
            setShowAllocateModal(false);
            setSelectedVisitor(null);
            // GRE: remove allocated visitor from list immediately (disappearance logic – same as app)
            if (leadIdToRemove) {
              lastAllocatedLeadIdRef.current = leadIdToRemove;
              const idStr = String(leadIdToRemove);
              setVisitorList((prev) =>
                Array.isArray(prev)
                  ? prev.filter(
                      (v) => String(v._id || v.lead_id || "") !== idStr,
                    )
                  : prev,
              );
            }
            // Refresh visitor list from API to keep in sync
            if (isAdmin) {
              dispatch(
                visitorList({
                  search_type: cpId ? 1 : 2,
                  limit: 10,
                  offset: page,
                }),
              );
            } else {
              dispatch(getVisiterList({ limit: 10, offset: page }));
            }
          }}
        />
      )}
    </div>
  );
};
export default Visitor;
